exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-cara-tsx": () => import("./../../../src/templates/cara.tsx" /* webpackChunkName: "component---src-templates-cara-tsx" */)
}

